import { IColorByValueAttributeMap } from 'app/services/api/colorByValue'
import OverlayScrollbar from 'common/components/OverlayScrollBar'

import ColorThresholdCustomizer from './ColorThresholdCustomizer'
import PaletteSelectPreview from './PaletteSelectPreview'

interface IColorByValueCustomizeColorModalContent {
  attributeMap: IColorByValueAttributeMap | null
  setAttributeMap: (attributeMap: IColorByValueAttributeMap) => void
  setDataErrors: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >
  resetStagingConfig: () => void
}

export interface IColorByValueCustomizeColorModalInnerContent {
  attributeMap: IColorByValueAttributeMap
  setAttributeMap: (attributeMap: IColorByValueAttributeMap) => void
  reset?: () => void
}

const Content = ({
  attributeMap,
  setAttributeMap,
  setDataErrors,
  resetStagingConfig
}: IColorByValueCustomizeColorModalContent) => {
  if (attributeMap == null) {
    return (
      <div className='flex flex-1 items-center justify-center'>
        Please select an attribute
      </div>
    )
  }

  return (
    <OverlayScrollbar>
      <div className='mx-10 mb-4 mt-6 min-w-100 flex-1'>
        <PaletteSelectPreview
          attributeMap={attributeMap}
          setAttributeMap={setAttributeMap}
        />
        <div className='my-8' />
        <ColorThresholdCustomizer
          attributeMap={attributeMap}
          setAttributeMap={setAttributeMap}
          setDataErrors={setDataErrors}
          reset={resetStagingConfig}
        />
      </div>
    </OverlayScrollbar>
  )
}

export default Content
